import React, { useEffect } from "react";
import Types from "prop-types";
import { withTranslation } from "react-i18next";
import eventAnalytics from "../../analytikaV2";
import { ANALYTIKA_EVENTS } from "../../utils/constants";
import { styles } from "./MotInviteSwitchAccount.styles";
import LogoutIcon from "../../images/icn_logout.svg";
import CareemPartnerLogo from "../../images/icn_careem_partner_logo.svg";

const MotInviteSwitchAccount = ({ t, onLogout }) => {
  useEffect(() => {
    eventAnalytics.setPageName(ANALYTIKA_EVENTS.PAGE.BUSINESS_INVITATION_SWITCH_ACCOUNT);
    eventAnalytics.publishV2(ANALYTIKA_EVENTS.IDNW_VIEW_PAGE, {
      page_name: ANALYTIKA_EVENTS.PAGE.BUSINESS_INVITATION_SWITCH_ACCOUNT,
    });
  }, []);

  const handleLogout = (event) => {
    event.preventDefault();
    eventAnalytics.publishV2(ANALYTIKA_EVENTS.IDNW_TAP_BUTTON, {
      button_name: "logout_and_continue",
    });
    if (onLogout) {
      onLogout();
    } else {
      window.location.assign("/logout");
    }
  };

  return (
    <div>
      <header style={styles.header}>
        <div style={styles.headerBrand}>
          <div style={styles.headerLogo}>
            <img src={CareemPartnerLogo} alt="" aria-hidden="true" style={styles.headerLogoImg} />
          </div>
          <h1 style={styles.headerTitle}>
            <span style={{ fontWeight: "400" }}>Careem </span>Partner
          </h1>
        </div>
        <p style={styles.headerSubtitle}>
          {t("business_invitation:you_have_been_invited")}
        </p>
      </header>

      <main style={styles.content}>
        <div style={styles.warningIconWrapper} aria-hidden="true">
          <div style={styles.warningIconCircle}>
            <span style={styles.warningIconText}>!</span>
          </div>
        </div>

        <h2 style={styles.pageTitle}>
          {t("business_invitation:switch_account_required")}
        </h2>

        <div style={styles.infoCard} role="alert">
          <p style={styles.infoCardBody}>
            {t("business_invitation:switch_account_body")}
          </p>
          <div style={styles.infoCardDivider} />
          <p style={styles.infoCardWarning}>
            {t("business_invitation:switch_account_logout_hint")}
          </p>
        </div>

        <button
          style={styles.logoutButton}
          onClick={handleLogout}
          aria-label={t("business_invitation:logout_and_continue")}
        >
          {t("business_invitation:logout_and_continue")}
          <img src={LogoutIcon} alt="" aria-hidden="true" style={styles.logoutIconImg} />
        </button>
      </main>
    </div>
  );
};

MotInviteSwitchAccount.propTypes = {
  t: Types.func.isRequired,
  onLogout: Types.func,
};

export default withTranslation()(MotInviteSwitchAccount);
export const MotInviteSwitchAccountUnwrapped = MotInviteSwitchAccount;
